import Subheading from 'components/Subheading';
import WeeklyDrawNumberPicker from 'components/WeeklyDrawNumberPicker';
import PopupWithDimmedBackground from 'components/PopupWithDimmedBackground';
import React, { useEffect, useState } from 'react';
import { colors } from 'utils/constants';

interface IWeeklyDrawNumberPickerPopup {
  showPopup: boolean;
  prepopulateMainNumbers: number[];
  prepopulateBonusNumbers: number[];
  numberRanges: number[];
  bonusNumberRanges: number[];
  onConfirmNumbers: (mainNumbers: number[], bonusNumbers: number[]) => void;
  onClose: () => void;
  glowColor: string;
}

const WeeklyDrawNumberPickerPopup = ({
  showPopup,
  prepopulateMainNumbers,
  prepopulateBonusNumbers,
  numberRanges,
  bonusNumberRanges,
  onConfirmNumbers,
  onClose,
}: IWeeklyDrawNumberPickerPopup) => {
  const [numbersHaveChanged, setNumbersHaveChanged] = useState(false);
  useEffect(() => {
    if (showPopup) {
      setNumbersHaveChanged(false);
    }
  }, [showPopup]);

  if (!showPopup) {
    return null;
  }

  const onCloseClicked = () => {
    if (
      !numbersHaveChanged ||
      confirm(
        "Your numbers have changed, but you have not pressed 'confirm'. Are you sure that you want to close the number picker?",
      )
    ) {
      onClose();
    }
  };

  return (
    <PopupWithDimmedBackground
      additionalClassName="weeklyDrawNumberPickerPopup"
      onClose={onCloseClicked}
      maxWidth={640}
      margin="8px 0 0 0"
    >
      <h2
        className="aboutUsTypographyHeaderXlargeOnWhite"
        data-text="Choose numbers"
      >
        Choose numbers
      </h2>

      <WeeklyDrawNumberPicker
        prepopulateMainNumbers={prepopulateMainNumbers}
        prepopulateBonusNumbers={prepopulateBonusNumbers}
        numberRanges={numberRanges}
        bonusNumberRanges={bonusNumberRanges}
        onConfirmNumbers={(mainNumbers: number[], bonusNumbers: number[]) => {
          onConfirmNumbers(mainNumbers, bonusNumbers);
          onClose();
        }}
        onNumberChange={() => setNumbersHaveChanged(true)}
      />

      <div className="cancelButton" onClick={onClose}>
        Cancel
      </div>

      <style jsx>
        {`
          .cancelButton {
            font-weight: 700;
            color: ${colors.primaryBrandGray}80;
            cursor: pointer;
            margin-top: 16px;
          }
        `}
      </style>
    </PopupWithDimmedBackground>
  );
};

export default WeeklyDrawNumberPickerPopup;
